import type { Variants } from "motion/react";
import { duration, easing } from "./tokens";

/**
 * Shared Motion variants. Components import these by name so the
 * vocabulary of "what does a reveal feel like" stays consistent across
 * the site. Component-specific variants belong next to the component,
 * not in here.
 */

/** Fade + small upward translate. The default site-wide reveal. */
export const revealUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: duration.md, ease: easing.out },
  },
};

/** Same shape, larger travel — for hero-scale entrances. */
export const revealUpLarge: Variants = {
  hidden: { opacity: 0, y: 48 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: duration.lg, ease: easing.outExpo },
  },
};

/** Plain fade — for elements where vertical movement is jarring (logos, dividers). */
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: duration.md, ease: easing.out },
  },
};

/**
 * Stagger container — pair with a child variant on each direct child to
 * cascade their entrances. The container itself has no visual change.
 */
export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};
